import { Snackbar } from "@mui/material";
import { useState } from "react";
import { SnackBarContext } from "../../contexts/SnackbarContext";

function SnackbarComponenet(props) {
  const [open, setOpen] = useState(props?.open);
  const handleClose = (event) => {
    setOpen(false);
    props?.onClose(false);
};
  return (
    <div>
      <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            open={open} 
            color={"success"}
            autoHideDuration={5000}
            message={props?.message} 
            onClose={handleClose} 
       />
    </div>
  );
}


const SnackBarProvider = (props) => {
  const onSnackbarclose=((value)=>{
    update((prev) => ({
      ...prev,
      showSnackBar : false,
      message:null
    }));
  })
  const show = (message) => {
    update((prev) => ({
      ...prev,
      showSnackBar : true,
      message:message
    }));
  };

  const [state, update] = useState({
    showSnackBar: false,
    message : null,
    show
  }); 
  return (
    <SnackBarContext.Provider value={state}>
      {state.showSnackBar ? <SnackbarComponenet open={state?.showSnackBar} onClose={onSnackbarclose} message={state.message}/> : null}
      {props?.children}
    </SnackBarContext.Provider>
  );
};

export default SnackBarProvider;